import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.primary.cards,
    boxShadow: theme.palette.primary.cardsBox,
    borderRadius: '8px',
    height: 'auto',
  },
  clickable: {
    cursor: 'pointer',
    '&:hover': {
      border: '1px solid #01B5DE',
      background: theme.palette.primary.hover
    }
  }
}));

const Cards = props => {
  const classes = useStyles();
  const { className, children, isClickable, ...remaingProps } = props
  return <Box className={`${classes.root} ${className} ${isClickable ? classes.clickable : ''}`} {...remaingProps}>{children}</Box>;
};

export default Cards;
